import { EldmlTransform } from "./EldmlTransform";

export class SpreadsheetTransform extends EldmlTransform {
  apply() {
    this.selector.find("spreadsheet").each((_, element) => {
      this.transformer.processSpreadsheet(element);
    });
  }
}
